import React from 'react';
import PropTypes from 'prop-types';
import formatMessage from 'format-message';
import * as searchPaths from '../../constants/search-paths';
import * as paginatedPageSizes from '../../constants/paginated-page-sizes';
import { createFetchResults } from '../../common/util/create-fetch-results';

// Components
import FavoriteResourcesList from './favorite-resources-list';
import NoResultsQuote from '../common/no-results-quote';
import starUrl from '../../../assets/svg/star-flag.svg';
import noResultsUrl from '../../../assets/svg/no_result.svg';

// Stores
import ResultsStore from '../../stores/results';
import { resourceTypes } from '../../common/app-constants';
import FavoriteResourceImportStatusScreenReaderContent from './favorite-resource-import-status-screenreadercontent';

const getEmptyMessage = ({ types, q }) => {
  const resourceType = resourceTypes[types];
  if (q) {
    return formatMessage('No Results Found');
  }
  if (!resourceType) {
    return formatMessage('Currently No Favorites');
  }
  return formatMessage('No Favorite {type}', {
    type: resourceTypes[types].pluralName
  });
};

const getQuote = ({ types, q }) => {
  if (q) {
    return null;
  }
  return formatMessage(
    'Add favorites from Commons by clicking the "Add to Favorites" link in the Resource details page.'
  );
};

const getNoResultProps = query => {
  const { q } = query;
  return {
    className: q ? '' : 'small',
    photoUrl: q ? noResultsUrl : starUrl,
    message: getEmptyMessage(query),
    quote: getQuote(query),
    photoAlt: formatMessage('Icon')
  };
};

export default class FavoriteResourcesHandler extends React.Component {
  static displayName = 'FavoriteResourcesHandler';

  static propTypes = {
    session: PropTypes.object,
    favorites: PropTypes.object
  };

  render () {
    const {
      router,
      importStatus
    } = this.props;

    const noResultsProps = getNoResultProps(router.query);

    const resultsPerPage = paginatedPageSizes.FAVORITES_TRAY_PAGE_SIZE;
    const fetchResults = createFetchResults(searchPaths.RESOURCES_FAVORITES_TRAY, resultsPerPage);

    return (
      <React.Fragment>
        <FavoriteResourceImportStatusScreenReaderContent importStatus={importStatus} />
        <FavoriteResourcesList
          baseParams={{
            onlyFavorites: true,
            exportStatus: 'complete'
          }}
          fetchResults={fetchResults}
          resultsPerPage={resultsPerPage}
          queryArialLabel={formatMessage(
            'Search My Favorited Resources for course resources by keyword, author, institution, or title'
          )}
          isLoading={ResultsStore.showLoading()}
          showFavoriteOptions
          emptyMessage={<NoResultsQuote {...noResultsProps} />}
          canShowPublic={!this.props.session.publicOnly}
          {...this.props}
        />
      </React.Fragment>
    );
  }
}
